import { React, useEffect, useRef } from "react";
import "./About.css";
import profile2 from "../../images/portfolio-2.png";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/all";

const About = () => {
  const container = useRef(null);
  gsap.registerPlugin(ScrollTrigger);
  useEffect(() => {
    const el = container.current;
    gsap.fromTo(
      ".about__container",
      {
        scale: 0.7,
      },
      {
        scale: 1,
        scrollTrigger: {
          trigger: el,
          scrub: true,
        },
      },
      {}
    );
  });
  return (
    <section id="about">
      <div className="section__wrapper about__container">
        <div className="me__container blur-effect">
          <div className="photo__container">
            <img src={profile2} alt="Profile" className="profile-image" />
          </div>
        </div>
        <div className="section__header">
          <h2 className="primary__title">Про мене</h2>
          <h1 className="title">
            <span className="color__primary">
              Розробник програмного забезпечення
            </span>
          </h1>

          <p className="text__muted description">
            Активно розвиваю свої навички, працюючи над особистими проєктами та
            вивчаючи нові технології. Я захоплена створенням ефективних та
            надійних веб-додатків і завжди готова до нових викликів та
            можливостей.
          </p>
        </div>
      </div>
    </section>
  );
};

export default About;
